import axios from 'axios';
import config from 'api/urls-config.json';
import { product_items_per_request } from 'api/constants';

export const getCropNutrition = params => {
    return axios.get(`${config.API + config.pages.crop_nutrition_programs}`, { params });
};

export const getCropNutritionDetail = params => {
    const { slug, language, country } = params;

    return axios.get(`${config.API + config.pages.crop_nutrition_programs_slug + slug}`, {
        params: {
            language,
            country,
        },
    });
};

export const getCropsForProductByTypeAndTrialsCountry = params => {
    const { slug, language, country, trials_country, type, page = 1, limit = product_items_per_request, all } = params;
    // all for filters
    return axios.get(`${config.API + config.crops}`, {
        params: {
            language,
            country,
            product: slug,
            trials_country,
            type,
            page,
            limit,
            all,
        },
    });
};
